module.exports = __webpack_public_path__ + "img/time-deposit.a291ccce.png";